"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardSize;
(function (CardSize) {
    CardSize["FLUSH"] = "flush";
    CardSize["XS"] = "xs";
    CardSize["SM"] = "sm";
    CardSize["BASE"] = "base";
})(CardSize = exports.CardSize || (exports.CardSize = {}));
//# sourceMappingURL=CardSize.enum.js.map